var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[[\"C:\\\\Users\\\\vbastos\\\\AppData\\\\Roaming\\\\npm\\\\node_modules\\\\front-cli\\\\node_modules\\\\babel-preset-env\\\\lib\\\\index.js\",{\"targets\":{\"browsers\":[\"ie >= 9\"]},\"modules\":false,\"useBuiltIns\":true,\"debug\":false}]],\"compact\":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./radio.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a1285bd8\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./radio.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Repositorios\\AGENDA_PREFEITO\\front-end\\application\\components\\form\\radio.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] radio.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a1285bd8", Component.options)
  } else {
    hotAPI.reload("data-v-a1285bd8", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./application/components/form/radio.vue
// module id = 402
// module chunks = 1